"use strict";

angular.module("core").directive("stdaddress", function() {
    return {
        restrict: "E",
        templateUrl: require("./std-address.directive.html"),
        scope: {Address: "<source", Name: "<name", hideExtra: "<?"},
        controller: function($scope) {
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/std-address/std-address.directive.js
// module id = 483
// module chunks = 0